import TickIcon from "@/assets/icons/tick.svg?react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, ImportantNote, Typography } from "@/components/ui";
import { Button } from "@/components/ui/button";

export interface JobDetailsSchema {
  job_number: string;
  customer_number: string;
  plant_name: string;
  service_name: string;
  design_code: string;
  branch: string;
}

interface ConfirmJobDetailsProps {
  confirmData: JobDetailsSchema | null;
  setConfirmData: (data: JobDetailsSchema | null) => void;
  handleSaveJobDetails: () => void;
}

export function ConfirmJobDetails({ confirmData, setConfirmData, handleSaveJobDetails }: ConfirmJobDetailsProps) {
  function handleCancel() {
    setConfirmData(null);
  }

  return (
    <Dialog open={!!confirmData} onOpenChange={() => setConfirmData(null)}>
      <DialogContent>
        <DialogTitle>Confirm job details</DialogTitle>
        <DialogDescription>Review and confirm your job details before saving</DialogDescription>
        <div className="flex w-[300px] flex-col md:w-[400px]">
          <div className="mb-4 flex justify-between">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-success-50">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-success-100">
                <TickIcon className="h-[11px] w-[16px]" />
              </div>
            </div>
          </div>
          <ImportantNote>Additionally, please confirm the details below are correct</ImportantNote>
          {confirmData && (
            <div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Job Number:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.job_number}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Plant Name:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.plant_name}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Customer Number:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.customer_number}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Service:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.service_name}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Design code:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.design_code || "N/A"}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-1 sm:grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Branch:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.branch || "N/A"}
                </Typography>
              </div>
            </div>
          )}
          <div className="mt-8 flex gap-2">
            <Button variant="outline" className="flex-1 self-end" onClick={handleCancel}>
              Cancel
            </Button>
            <Button className="flex-1 self-end" onClick={handleSaveJobDetails}>
              Confirm
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
